import {NavItemProps, FormLabels} from '../../containers/layouts/routesConfig';
import api, {ROUTES} from '../index';

let menuBuilder: any[] = [
  {
    RoleID: 1,
    UserDetailID: 2,
    RoleName: 'Admin',
    IsDefaultRole: 1,
    Forms: [
      {
        ID: 0,
        HasShow: false,
        IsForm: 1,
        Actions: [
          {
            ID: 'Are you sure to delete?',
            Name: 'Are you sure to delete?',
            FormObjectTypeID: 3,
          },
        ],
      },
      {
        ID: 1,
        Name: 'Basic Data',
        HasShow: true,
        IsForm: 0,
        URL: '/cargo/rate-class/2',
      },
      {
        ID: 6,
        Name: 'Parent Test',
        HasShow: true,
        IsForm: 0,
        URL: '',
      },
      {
        ID: 2,
        Name: 'Rate Class',
        HasShow: true,
        IsForm: 1,
        URL: '/cargo/rate-class/2',
        ParentID: 1,
        Actions: [
          {
            ID: 'Name',
            Name: 'Name',
            FormObjectTypeID: 1,
          },
          {
            ID: 'From_Weight',
            Name: 'From Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'To_Weight',
            Name: 'To Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'CalculationType',
            Name: 'CalculationType',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Factor',
            Name: 'Factor',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Add',
            Name: 'Add',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Edit',
            Name: 'Edit',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Delete',
            Name: 'Delete',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'RowNo',
            Name: 'RowNo',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Origin',
            Name: 'Origin',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Destination',
            Name: 'Destination',
            FormObjectTypeID: 1,
          },
          {
            ID: 'FromDate',
            Name: 'FromDate',
            FormObjectTypeID: 1,
          },
          {
            ID: 'ToDate',
            Name: 'ToDate',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Add Customize',
            Name: 'Add Customize',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Edit Customize',
            Name: 'Edit',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Delete Customize',
            Name: 'Delete',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
        ],
      },
      {
        ID: 5,
        Name: 'Pricing',
        HasShow: true,
        IsForm: 1,
        URL: '/cargo/pricing/3',
        ParentID: 1,
      },
      {
        ID: 3,
        Name: 'Define Rate Class',
        HasShow: false,
        IsForm: 1,
        URL: '',
        ParentID: 2,
        Actions: [
          {
            ID: 'Name',
            Name: 'Name',
            FormObjectTypeID: 1,
          },
          {
            ID: 'From_Weight',
            Name: 'From Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'To_Weight',
            Name: 'To Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Per_Kiloo',
            Name: 'Per Kg',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Total',
            Name: 'Total',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Description',
            Name: 'Description',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Factor',
            Name: 'Factor',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Disabled',
            Name: 'Disabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Enabled',
            Name: 'Enabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Cancel',
            Name: 'Cancel',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Save',
            Name: 'Save',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
        ],
      },
      {
        ID: 4,
        Name: 'Customize Rate Class',
        HasShow: false,
        IsForm: 1,
        ParentID: 2,
        Actions: [
          {
            ID: 'Origin',
            Name: 'Origin',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Destination',
            Name: 'Destination',
            FormObjectTypeID: 1,
          },
          {
            ID: 'FromDatetime',
            Name: 'FromDatetime',
            FormObjectTypeID: 1,
          },
          {
            ID: 'ToDatetime',
            Name: 'ToDatetime',
            FormObjectTypeID: 1,
          },
          {
            ID: 'From_Weight',
            Name: 'From Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'To_Weight',
            Name: 'To Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Per_Kiloo',
            Name: 'Per Kg',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Total',
            Name: 'Total',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Description',
            Name: 'Description',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Disabled',
            Name: 'Disabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Enabled',
            Name: 'Enabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Cancel',
            Name: 'Cancel',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
          {
            ID: 'Save',
            Name: 'Save',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
        ],
      },
    ],
  },
  {
    RoleID: 2,
    UserDetailID: 8,
    RoleName: 'Commercial Manager',
    IsDefaultRole: 0,
    Forms: [
      {
        ID: 0,
        HasShow: false,
        IsForm: 1,
        Actions: [
          {
            ID: 'Are you sure to delete?',
            Name: 'Are you sure to delete?',
            FormObjectTypeID: 3,
          },
        ],
      },
      {
        ID: 1,
        Name: 'Basic Data',
        HasShow: true,
        IsForm: 0,
        URL: '',
      },
      {
        ID: 2,
        Name: 'Rate Class',
        HasShow: true,
        IsForm: 1,
        URL: '',
        ParentID: 1,
        Actions: [
          {
            ID: 'Name',
            Name: 'Name',
            FormObjectTypeID: 1,
          },
          {
            ID: 'From_Weight',
            Name: 'From Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'To_Weight',
            Name: 'To Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'CalculationType',
            Name: 'CalculationType',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Factor',
            Name: 'Factor',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Add',
            Name: 'Add',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
          {
            ID: 'Edit',
            Name: 'Edit',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Delete',
            Name: 'Delete',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
          {
            ID: 'RowNo',
            Name: 'RowNo',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Origin',
            Name: 'Origin',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Destination',
            Name: 'Destination',
            FormObjectTypeID: 1,
          },
          {
            ID: 'FromDate',
            Name: 'FromDate',
            FormObjectTypeID: 1,
          },
          {
            ID: 'ToDate',
            Name: 'ToDate',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Add Customize',
            Name: 'Add Customize',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
          {
            ID: 'Edit Customize',
            Name: 'Edit',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
          {
            ID: 'Delete Customize',
            Name: 'Delete',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
        ],
      },
      {
        ID: 3,
        Name: 'Define Rate Class',
        HasShow: false,
        IsForm: 1,
        URL: '',
        ParentID: 2,
        Actions: [
          {
            ID: 'Name',
            Name: 'Name',
            FormObjectTypeID: 1,
          },
          {
            ID: 'From_Weight',
            Name: 'From Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'To_Weight',
            Name: 'To Weight',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Per_Kiloo',
            Name: 'Per Kg',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Total',
            Name: 'Total',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Description',
            Name: 'Description',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Factor',
            Name: 'Factor',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Disabled',
            Name: 'Disabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Enabled',
            Name: 'Enabled',
            FormObjectTypeID: 1,
          },
          {
            ID: 'Cancel',
            Name: 'Cancel',
            FormObjectTypeID: 2,
            HasAccess: 1,
          },
          {
            ID: 'Save',
            Name: 'Save',
            FormObjectTypeID: 2,
            HasAccess: 0,
          },
        ],
      },
    ],
  },
];

export const JsonToMenu: (
  activeRole: any,
  data: any[],
  lang: string,
) => NavItemProps[] = (activeRole, data, lang) => {
  const forms = data.find((role: any) => role.UserDetailID === activeRole)
    ?.Forms;
  // const forms = data.find((role: any) => role.RoleID === activeRole)?.Forms;
  if (forms) {
    const newForms: NavItemProps[] = forms
      .filter((item: any) => item.Name)
      .map((item: any) => ({
        id: item.ID.toString(),
        messageId: item.Name || '',
        title: item.Name || '',
        parentId: item.ParentID ? item.ParentID.toString() : undefined,
        children: [],
        url: item.URL || '', //?
        type: item.IsForm === 1 ? 'item' : 'collapse',
      }));
    for (let i = 0; i < newForms.length; i++) {
      if (newForms[i].parentId !== undefined) {
        const parentId = newForms[i].parentId;
        const parentIndex = newForms.findIndex((item) => item.id === parentId);
        if (parentIndex >= 0) {
          newForms[parentIndex].children?.push(newForms[i]);
        }
      }
    }
    return newForms.filter((x) => x.parentId === undefined);
  }
  return [];
};

export const JsonToMenuLevel: (
  activeRole: any,
  data: any[],
  lang: string,
) => NavItemProps[] = (activeRole, data, lang) => {
  const forms = data.find((role: any) => role.UserDetailID === activeRole)
    ?.Forms;
  // const forms = data.find((role: any) => role.RoleID === activeRole)?.Forms;
  if (forms) {
    const newForms: NavItemProps[] = forms
      .filter((item: any) => item.Name)
      .map((item: any) => ({
        id: item.ID.toString(),
        messageId: item.Name || '',
        Name: item.Name || '',
        parentId: item.ParentID ? item.ParentID.toString() : undefined,
        // actions: [],
        url: item.URL || '', //?
        actions: item.Actions || '', //?
        children: [], //?
        type: item.IsForm === 1 ? 'item' : 'collapse',
      }));
    for (let i = 0; i < newForms.length; i++) {
      if (newForms[i].parentId !== undefined) {
        const parentId = newForms[i].parentId;
        const parentIndex = newForms.findIndex((item) => item.id === parentId);
        if (parentIndex >= 0) {
          newForms[parentIndex].children?.push(newForms[i]);
        }
      }
    }
    return newForms.filter((x) => x.parentId === undefined);
  }
  return [];
};

//it used in horizontal menu.
export const toRoutesConfig: (lang: string) => NavItemProps[] = (lang) => {
  const findDefaultMenu = (menu: any[]): number => {
    const defaultIndex = menu.findIndex((item) => item.IsDefaultRole === 1);
    return defaultIndex === -1 ? 0 : defaultIndex;
  };
  const defaultIndex = findDefaultMenu(menuBuilder);
  const forms = [...menuBuilder[defaultIndex].Forms];
  const newForms: NavItemProps[] = forms
    .filter((item) => item.Name)
    .map((item) => ({
      id: item.ID.toString(),
      messageId: item.Name || '',
      title: item.Name || '',
      parentId: item.ParentID ? item.ParentID.toString() : undefined,
      children: [],
      url: item.URL || '', //?
      type: item.IsForm === 1 ? 'item' : 'collapse',
    }));
  for (let i = 0; i < newForms.length; i++) {
    if (newForms[i].parentId !== undefined) {
      const parentId = newForms[i].parentId;
      const parentIndex = newForms.findIndex((item) => item.id === parentId);
      if (parentIndex >= 0) {
        newForms[parentIndex].children?.push(newForms[i]);
      }
    }
  }
  return newForms.filter((x) => x.parentId === undefined);
};

// export const toRoute=(lang:string)=>{
// 	const initiaActiveJson=menuBuilder.find(item=>item.IsDefaultRole===1);
// 	const roleName=initiaActiveJson.RoleName;
// 	const forms=initiaActiveJson.Forms.map((f:any)=>({...f,children:[]}));

// 	let f:any=undefined;
// 	const forms_=forms.filter((x:any)=>x.HasShow!==false);
// 	for(f of forms_){
// 		if(f.ParentID){
// 			const index=forms_.findIndex((item:any)=>item.ID===f.ParentID);
// 			if(index>=0){
// 				forms_[index].children.push(f);
// 			}
// 		}
// 	}

// 	// const treeForms

// 	const trans=forms.filter((item:any)=>!!item.Actions);
// 	const translates:FormLabels[]=trans.map((item:any)=>{
// 		const id=item.ID;
// 		const labels=item.Actions.map((x:any)=>{
// 			return {id:x.ID,name:x.Name,hasAccess:x.HasAccess,type:x.FormObjectTypeID};
// 		});
// 		return {
// 			id,
// 			labels,
// 		}
// 	})

// }
// toRoute('FA');

export const jsonToRoutesConfig: (lang: string) => NavItemProps[] = (lang) => {
  const route = toRoutesConfig(lang);
  return route;
};

export const jsonToTranslate = (
  activeRole: any,
  data: any[],
  name: string,
): any => {
  const forms = data.find((role: any) => role.UserDetailID === activeRole)
    ?.Forms;
  // const forms = data.find((role: any) => role.RoleID === activeRole)?.Forms;
  if (forms) {
    const formFiter = forms.filter((item: any) => !!item.Actions);

    const dictionary: any = formFiter.map((item: any) => ({
      id: item.ID,
      labels: item?.Actions?.map((action: any) => ({
        id: action.ID,
        name: action.Name || '',
        hasAccess: !!action.HasAccess,
        type: action.FormObjectTypeID === 1 ? 'input' : 'button',
      })),
    }));
    return dictionary;
  }
};

export const translateLabels = (name: string): FormLabels[] => {
  const findDefaultMenu = (menu: any[]): number => {
    const defaultIndex = menu.findIndex((item) => item.IsDefaultRole === 1);
    return defaultIndex === -1 ? 0 : defaultIndex;
  };
  const defaultIndex = findDefaultMenu(menuBuilder);
  const forms = [...menuBuilder[defaultIndex].Forms];
  const formFiter = forms.filter((item) => !!item.Actions);

  const dictionary: any = formFiter.map((item: any) => ({
    id: item.ID,
    labels: item?.Actions?.map((action: any) => ({
      id: action.ID,
      name: action.Name || '',
      hasAccess: !!action.HasAccess,
      type: action.FormObjectTypeID === 1 ? 'input' : 'button',
    })),
  }));
  return dictionary;
};

// export const getMenu=(params:any,cb:(err:any,data:any)=>void)=>{
// 	api.post(ROUTES.AUTH,
// 		params
// 		,(err,data)=>{
// 			if(!err){
// 				const mapData=JsonToMenu(JSON.parse(data[0].MenuForms),'FA');
// 				cb(err,mapData);
// 			} else {
// 				cb(err,null);
// 			}
// 	})
// }

export const getAllMenuData = (
  params: any,
  cb: (err: any, data: any) => void,
) => {
  api.post(ROUTES.AUTH, params, cb);
};
